import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { NavItems } from '@shared/Frontend/components/navItems'
import { fieldUpdater } from '@shared/Frontend/utils/updaters'
import { AsyncState, Maybe, Template, Unit, unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { NavigationTemplate } from '../navigation/navigation.template'
import { CMSFooterState } from './cmsFooter.state'

export type CMSFooterView = {
  CMSFooter: (_: {
    menuItems: NavItems
  }) => ReactNode
}

export const CMSFooterTemplate = Template.Default<Unit, CMSFooterState, Unit, CMSFooterView>(
  ({ context, setState, view }) => (
    <>
      <NavigationTemplate
        context={{ ...context.menuItems, slug: 'footer' }}
        setState={(updater) => setState(fieldUpdater<CMSFooterState>()('menuItems')(updater))}
        foreignMutations={unit}
        view={unit}
      />
      <view.CMSFooter
        menuItems={
          AsyncState.Operations.hasValue(context.menuItems) && context.menuItems.value
            ? context.menuItems.value
            : []
        }
      />
    </>
  )
)
